export default __webpack_public_path__ + "static/media/product-2.43de17b1.jpg";